import "@styles/index.css";
import "@rasenganjs/image/lib/styles/index.css";
import "@styles/app.css";

import React from "react";
import AppRouter from "@app/app.router";

export default function App({ Component, children }) {
  return <Component router={AppRouter}>{children}</Component>;
}
